export default __webpack_public_path__ + "static/media/teacher-select.18e3e62d.png";